<template>
  <div>
    <headerNav title="销售奖励查询" />
    <div class="cheader">
             <div class="cmoneys"  :style="{color:$abctheme.basecolor}" >
                <div class="cmoney-wz">
                    金额
                </div>
                <div class="cmoney-money">
                    <div><span>￥</span>{{userInfo.teamSaleReward||"0.00"}}</div>
                </div>
            </div>
            <!-- <div class="cbtns">
                <button @click="fshow">提现</button>
            </div> -->
    </div>
    <div>
        <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky>
             
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
                    <van-list
                        v-model="navitem.loaded"
                        :finished="navitem.loadingType=='nomore'?true:false"
                        :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                        @load="loadData"
                    >
                       
                            <div v-for="(item,index) in navitem.list" class="mian-list" :key="index">
                                <div v-if="navitem.state==0">
                                     <div class="mian-list-info">
                                        <div class="mian-list-info-data">
                                        <span>订单号:</span>
                                        <span>{{item.tid}}</span>
                                        </div>
                                        <div class="mian-list-info-data">
                                            <span>类型:</span>
                                            <span>{{item.memberTeamSaleRewardTypeName}}</span>
                                        </div>
                                        <div class="mian-list-info-data">
                                        <span>金额:</span>
                                        <span class="red">￥{{item.money}}</span>
                                        <br>
                                        <!-- <van-tag type="success" class="mian-list-info-right-tag" v-if="item.isAudit==1" size="medium">{{item.balanceProductTypeName}}}</van-tag> -->
                                        </div>
                                        <div class="mian-list-info-data" v-if="item.comment">
                                            <span>备注:</span>
                                            <span>{{item.comment}}</span>
                                        </div>
                                        <div class="mian-list-info-data">
                                            <span>创建时间:</span>
                                            <span>{{item.creationTime}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="navitem.state==1">
                                    <div class="mian-list-info">
                                        <div class="mian-list-info-data">
                                        <span>订单号:</span>
                                        <span>{{item.tid}}</span>
                                        <van-tag type="primary" style="float:right" class="mian-list-info-left-tag"  v-if="item.auditStatus==1" size="medium">待审核</van-tag>
                                        <van-tag type="primary" style="float:right" class="mian-list-info-left-tag"  v-if="item.auditStatus==2" size="medium">通过</van-tag>
                                        <van-tag type="primary" style="float:right" class="mian-list-info-left-tag"  v-if="item.auditStatus==3" size="medium">不通过</van-tag>
                                        </div>
                                       
                                        <div class="mian-list-info-data">
                                        <span>金额:</span>
                                        <span class="red">￥{{item.money}}</span>
                                        <br>
                                        <!-- <van-tag type="success" class="mian-list-info-right-tag" v-if="item.isAudit==1" size="medium">{{item.balanceProductTypeName}}}</van-tag> -->
                                        </div>
                                        <div class="mian-list-info-data" v-if="item.comment">
                                            <span>备注:</span>
                                            <span>{{item.comment}}</span>
                                        </div>
                                        <div class="mian-list-info-data" v-if="item.creationTime">
                                            <span>创建时间:</span>
                                            <span>{{item.creationTime}}</span>
                                        </div>
                                    </div>
                                </div>  
                               
                            </div>
                    </van-list>
                    </van-tab>
            </van-pull-refresh>
          </van-tabs>
    </div>
    <van-dialog
      v-model="showtx"
      title="申请提现"
      show-cancel-button
      @confirm="txsumit"
      :before-close="beforeClose"
      close-on-popstate
    >
      <van-field v-model.number="money" ref="vfiled" label="金额" input-align="right" />
    </van-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      date: "",
      money:undefined,
      showtx:false,
      isok:false,
      tabCurrentIndex:0,
      navList:[
            {
            state: 0,
            text: '全部',
            loadingType: 'more',
            loaded:false,
            getparams: {
                "referralTypes":[],
                "sorting": "",
                "maxResultCount": 10,
                "skipCount": 0
            },
            list: [
            ]
            },
            // {
            // state: 1,
            // text: '提现',
            // loadingType: 'more',
            // loaded:false,
            // getparams: {
            //     "sorting": "",
            //     "maxResultCount": 10,
            //     "skipCount": 0
            // },
            // list: [
            // ]
            // },
        ]
      ,
      loading: false,
      finished: false,
      refreshing: false,
      userInfo:undefined,
      totalMoney:undefined
    };
  },
  created(){
      this.queruserinfo();
  },
  methods: {
    fshow()
    {
      this.money=undefined;
      this.showtx=true;
      setTimeout(() => {
          this.$refs.vfiled.focus(true);
      },0);
    },
    queruserinfo()
    {
      this.ajax.post("/api/services/app/PhoneUser/QueryUserInfo").then((x) => {
        this.userInfo = x.result;
        this.abp.userInfo = x.result;
      });
    },
    tabchange()
    {
        this.loadData('tabChange');
    },
    onRefresh()
    {
        this.loadData('refresh');
    },
    beforeClose(action, done) {
        if(action==='confirm')
        {
            done(this.isok);
        }
        else
        {
            done();
        }
    },
    txsumit()
    {
        
        if (!this.money||this.money<=0) {
            this.$dialog.alert({ message: "请输入正确的金额" });
            this.isok=false;
            return;
        }
        if(this.money>this.userInfo.teamSaleReward)
        {
            this.$dialog.alert({ message: "提现金额不能大于当前余额" });
            this.isok=false;
            return;
        }
        this.ajax.post('/api/services/app/PhoneTeamSaleReward/ApplyWithdraw?money='+this.money).then(x=>
        {
                this.$toast.success("提现成功");
                this.queruserinfo();
                this.loadalldata();
                this.showtx=false;
        }).finally
        (x=>
        {
            this.isok=true;
        });
    },
    loadalldata()
    {
        this.navList.forEach(x=>
        {   
            x.loadingType='refresh';
        })
        this.loadData();
    },
    loadData(source) {
         let index = this.tabCurrentIndex;
         let navItem = this.navList[index];
        // let state = navItem.state;
        
        if (source === 'tabChange' && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
            //防止重复加载
            if(source!="refresh")
            {
                return;
            }
            
        }
        if (source === 'refresh'||this.navList[index].loadingType=='refresh') {
            this.navList[index].list = [];
            this.navList[index].getparams.skipCount = 0;
        }
       
        this.navList[index].loadingType = 'loading';
        var params = navItem.getparams;
        //加载数据
        
        let url='/api/services/app/PhoneTeamSaleReward/QueryModelList';
        if(navItem.state==1)
        {
            url='/api/services/app/PhoneTeamSaleReward/QueryWithdrawPages';
        }
        this.ajax.post(url, params).then(x => {
        this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
        let totalcount = x.result.totalCount;
        
        this.navList[index].list = this.navList[index].list.concat(x.result.items);
        this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' :'nomore';
        }).finally(()=>
        {
            this.$set(this.navList[index], 'loaded', false);
            this.refreshing=false;
        });
    }
    
  },
};
</script>
<style lang="scss" scoped>
.mian-list{
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  padding-bottom: 20px;
}
.mian-list-info{
  padding: 5px 0;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.mian-list-info-data{
   min-height: 30px;
   padding-right: 20px;
}
.mian-list-info-right{
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-right-tag{
  position: absolute;
  right: 0;
}
.mian-list-mark{
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}
.red{
    color:red;
}
.cheader{
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    border-bottom:1px solid #e6e6e6;
}
.cmoneys
{
    display: inline-block;
    font-size: 14px;
    color:#c6bcf8;
    margin-right: 10px;
}

.cmoney-money
{
    font-size: 25px;
}
.cbtns{
    font-size: 20px;
}
.cbtns button
{
    background-color: #c6bcf8;
    color:white;
    border: 0;
    padding: 2px 30px;
    border-radius: 10px;
    box-shadow: 1px 1px 4px #e6e6e6;
}

</style>